import { FC } from "react";
import { Assurance } from "../../lib/interfaces/assurance.interface";
import { formatDate } from "../../lib/helpers/date_helpers";
import { MoreVertical } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DOCUMENTS_GROUPAMA } from "@/lib/constantes";

interface Props {
  assurance: Assurance;
}

const AssuranceItem: FC<Props> = ({ assurance }) => {
  return (
    <article className='relative flex items-start gap-3 pl-6 before:absolute before:bottom-[-1.5rem] before:left-[5px] before:top-4 before:w-px before:bg-slate-200 last:before:hidden'>
      <span className='absolute left-0 top-1.5 h-[11px] w-[11px] rounded-full border-[3px] border-[#39715f] bg-white' />
      <div className='min-w-0 flex-1'>
        <div className='font-semibold text-slate-900'>{assurance.typeAssurance?.description}</div>
        <div className='mt-1 text-sm leading-6 text-slate-600'>
          Du {formatDate(assurance.dateDebut)} au {formatDate(assurance.dateFin)} pour{" "}
          <strong className="font-semibold text-slate-800">{assurance.ruches}</strong> ruche
          {assurance.ruches === 1 ? "" : "s"}
        </div>
      </div>
      <div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              aria-label="Ouvrir les documents de l'assurance"
              className='-mr-2 shrink-0 text-slate-500 hover:bg-emerald-50 hover:text-emerald-800'
              variant={"ghost"}
              size={"icon"}
            >
              <MoreVertical className="h-5 w-5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuLabel>Documents Groupama</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <a href={DOCUMENTS_GROUPAMA.CONDITIONS_GENERALES_URL} target='_blank' rel='noreferrer'>
                Conditions générales
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <a href={DOCUMENTS_GROUPAMA.FRANCHISES_GARANTIES_URL} target='_blank' rel='noreferrer'>
                Franchises et garanties
              </a>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </article>
  );
};

export default AssuranceItem;
